import { Report196 } from "../../../components/borrowSystem/Report/Report196";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report196Container() {
  const titleName = `หลักสูตรการฝึกอบรมของสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อพัฒนาศักยภาพลูกจ้าง ภายใต้พระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545`
   //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report196 />
      <Footer />
    </div>
  );
}
